import z from "zod";

const translationPath = "page.4uBus.relationships.defaultRelationships.errors.";

const uBusRelationshipTypeSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  { invalid_type_error: translationPath + "u_bus_relationship_type" },
);

export const relationshipGroupItemSchema = z.object({
  id: z.string().optional(),
  enable: z.boolean(),
  default: z.boolean(),
  originName: z.string().min(1, translationPath + "origin_name"),
  originValue: z.string().min(1, translationPath + "origin_value"),
  destinyName: z.string().min(1, translationPath + "destiny_name"),
  destinyValue: z.string().min(1, translationPath + "destiny_value"),
  uBusRelationshipType: uBusRelationshipTypeSchema,
});

export type TRelationshipGroupItemForm = z.infer<
  typeof relationshipGroupItemSchema
>;
